import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import TimeService from 'app_services/time/timeService'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import { ICourseExtraInfo } from 'app_types/campus/academic/courseTypes'
import moment from 'moment'
import React, { FC, useMemo } from 'react'

import './StudentRelatedCourseItem.scss'

const DATE_FORMAT = 'DD/MM/YY'

interface IStudentRelatedCourseItemProps {
  course: ICourseSchedulingListItem
}

interface IExtendedCourse extends ICourseSchedulingListItem {
  extra_info: ICourseExtraInfo
}

const StudentRelatedCourseItem: FC<IStudentRelatedCourseItemProps> = ({ course }) => {
  const startDate = moment.utc(course?.startDate).format(DATE_FORMAT)
  const extraInfo = useMemo(() => (course as IExtendedCourse).extra_info, [course])
  const timeService = useMemo(() => new TimeService(), [])

  return (
    <div className="student-related-course-item--layout">
      <img src={extraInfo.coverUrl} alt="" />
      <div>
        <TextComponent color="#625B71">
          {course.program.name}
        </TextComponent>
        <div className='student-related-course-item--modality'>
          <TextComponent color="#625B71" fontSize="14px">
            Modalidad: {course.schedulingMode.name}
          </TextComponent>
          <TextComponent color="#625B71" fontSize="14px">
            Duración: {timeService.secondsFormatHMS(course.duration, 'HH')} Horas
          </TextComponent>
        </div>
        <TextComponent color="#625B71" fontSize="14px">
          Inicio: {startDate}
        </TextComponent>
      </div>
    </div>
  )
}

export default StudentRelatedCourseItem
